module.exports = __webpack_public_path__ + "static/media/YF16_8.f1a57110.jpg";